module.exports = __webpack_public_path__ + "media/operational-monitoring_en_ipad_new.a936ad4b.mp4";